// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timer-container[data-v-86480f76]{margin:2rem 1rem 1rem 1rem;display:flex;background:transparent linear-gradient(180deg,#eef0f2,hsla(0,0%,89.8%,.7176470588235294)) 0 0 no-repeat padding-box;border:1px solid #707070;border-radius:8rem;max-width:800px}.timer-items[data-v-86480f76]{width:200px;height:200px;color:red}@media screen and (max-width:480px){.timer-items[data-v-86480f76]{width:95px;height:95px}}", ""]);
// Exports
module.exports = exports;
